import {AgentSubTypes} from 'types';
import type {AgentsCountResult, SearchCountResultDto} from '../types';

export const mapAgentsCountResponseDto = (
  dto: SearchCountResultDto,
): AgentsCountResult => {
  const result: AgentsCountResult = {};
  for (let i = 0; i < AgentSubTypes.length; i++) {
    result[AgentSubTypes[i]] = dto.responses[i].hits.total.value;
  }
  return result;
};
